import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, useToast } from "@chakra-ui/react";
import PreSessionQuestionsService from "../../services/PreSessionQuestions";
import { PreSessionQuestionForm } from "./PreSessionQuestionForm";

const emptyForm = {
    question_text: "",
    helper_text: "",
    placeholder: "",
    input_type: "textarea",
    is_required: false,
    is_active: true,
    options: [] as Array<{ id: string; label: string }>,
    link: { text: "", url: "" },
};

export const AddPreSessionQuestion = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const token = localStorage.getItem("logged_in_user_token");
    const [form, setForm] = useState(emptyForm);
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setSaving(true);
        try {
            const payload = {
                ...form,
                link:
                    form.link?.text || form.link?.url
                        ? { text: form.link.text || "", url: form.link.url || "" }
                        : null,
                options: ["boolean", "mcq", "checkbox"].includes(form.input_type)
                    ? form.options
                    : [],
            };
            await PreSessionQuestionsService.add(payload, token);
            toast({
                position: "top",
                title: "Question created",
                status: "success",
                duration: 1500,
                isClosable: true,
            });
            navigate("/presession-questions");
        } catch (error: any) {
            console.log(error);
            toast({
                position: "top",
                title: "Failed to create question",
                description: error?.response?.data?.message || error.message,
                status: "error",
                duration: 2500,
                isClosable: true,
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="main-wrapper">
            <div className="page_title py-2">Add Pre-session Question</div>
            <Box p={5} bg="#f5f7f7" minH="calc(100vh - 48px)">
                <Text color="gray.600" fontSize="sm" mb={4}>
                    This question will appear on the mobile pre-session form after payment.
                </Text>
                <PreSessionQuestionForm
                    form={form}
                    setForm={setForm}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate("/presession-questions")}
                    saving={saving}
                    submitLabel="Create question"
                />
            </Box>
        </div>
    );
};